import { ScopeButton } from '@monorepo/shared-lib';
import { Form, Typography } from 'antd';
import { FormTextArea } from 'components/Custom/inputs';
import { LabelWrapper } from 'components/Custom/labels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnDrawerOff } from 'store/app/actions';
import { EmailDataParametersRequest } from 'store/vat/models/emailDataParametersRequest';

const { Text } = Typography;

interface NotApproveFormProps {
  setNotApproved: (values: EmailDataParametersRequest) => void;
}

export const NotApproveForm: React.FC<NotApproveFormProps> = ({
  setNotApproved,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = (values: any) => {
    const formValues = {
      ...values,
    } as EmailDataParametersRequest;

    setNotApproved(formValues);
    dispatch(turnDrawerOff());
  };

  return (
    <>
      <Text
        style={{
          fontSize: '18px',
          fontWeight: '400',
          lineHeight: '24px',
          textAlign: 'left',
          color: 'var(--color-text-muted, #5a6a6a)',
          marginBottom: '40px',
        }}
      >
        {t('vat-report.leave-note-to-submission-preparer-reasons-for-rejection')}
      </Text>
      <Form
        layout="horizontal"
        style={{
          marginTop: '40px',
        }}
        key={Date()}
        onFinish={handleSubmit}
      >
        <LabelWrapper>
          <span
            className="label-text"
            style={{ fontSize: 14, fontWeight: 400 }}
          >
            {t('common.note')}
          </span>
        </LabelWrapper>
        <Form.Item
          name="note"
          rules={[{ required: true, message: t('common.required-field') }]}
        >
          <FormTextArea rows={5} placeholder={t('common.enter-your-note')} />
        </Form.Item>
        <Form.Item>
          <ScopeButton //@ts-ignore
            width="100%"
            height="40px"
            type="primary"
            htmlType="submit"
          >
            {t('common.return-to-preparer')}
          </ScopeButton>
          <div style={{ marginTop: '20px' }}>
            <ScopeButton //@ts-ignore
              width="100%"
              height="40px"
              bg_color="var(--color-layout-bg, #E9F6F7)"
              type={'default'}
              onClick={() => dispatch(turnDrawerOff())}
            >
              {t('common.cancel')}
            </ScopeButton>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};
